import { app, Component } from 'apprun';
import { paginateAssets, PageSize, getPropertyLink, moveTo, $, showLoading, getPropertyIcon, hasPropertyType, hasExactPropertyType, checkMapList, checkValueInArray } from './utility';
import { getPropertyByID, getPropertiesInside_cosmos, sortProperties, getPropertyDetailStatusPrice, getGeoCode, getDeletedPropertyByID, getSimilarListing, getCommercialAgents } from './model/property';
import Porperty from './template/search-property-template';
import { lang, __ } from './Txlat';
import PageControl from './pageControl';
import './osm-map.ts';
import { SearchFilter } from './searchFilter';
import InquiryForm from './inquiry-form';
import { distance } from './model/tile';

declare const L;

function getMapProperties(properties) {
  const thumbnail = property => `${property.property_photo ? `<div class="item-header"><a target=property${property.id} href="${url(property)}"><img class="img-fluid" src="${property.property_photo}" alt="${property.address}"/></a></div>` : ''}`;
  const url = property => lang.get() === 'fr' ? getPropertyLink(property, 'fr') : getPropertyLink(property, 'en');

  const popup = (property) => {
    const sp = getPropertyDetailStatusPrice(property);
    return `<div class="item-wrap">
${thumbnail(property)}
<div class="item-body flex-grow-1">
<h2 class="item-title">
  <a target=property${property.id} href=${url(property)}>${property.address}</a>
</h2>
<ul class="list-unstyled item-info">
  ${sp.price ? `<li class="item-price">${sp.price}</li>` : ''}
  ${property.property_type ? `<li class="item-type">${lang.get() === 'en' ? (property.property_type[0] ? property.property_type[0].toUpperCase() : '') : (property.property_type[1] ? property.property_type[1].toUpperCase() : '')}</li>` : ''}
</ul>
</div>
</div>`;
  };

  return properties.map(property => ({
    id: property.id,
    title: property.address,
    lat: property.latitude,
    lng: property.longitude,
    marker: getPropertyIcon(property.property_type),
    retinaMarker: getPropertyIcon(property.property_type),
    popup: popup(property)
  }));
}

function setSort(sortBy) {
  const e = $('#ajax_sort_properties');
  for (let i = 0; i < e.getElementsByTagName('option').length; i++) {
    e.getElementsByTagName('option')[i].selected = e.getElementsByTagName('option')[i].value === sortBy;
  }
}

const filterProperties = function (state) {

  let allStatusStr = '';
  const statuses = document.getElementsByName('status[]')[0] as HTMLSelectElement;

  for (let i = 0; i < statuses.selectedOptions.length; i++) {
    if (statuses.selectedOptions[i].value) {
      if (allStatusStr === '') {
        allStatusStr = `'${statuses.selectedOptions[i].value.replace('for-', '')}'`;
      } else {
        allStatusStr += `,'${statuses.selectedOptions[i].value.replace('for-', '')}'`;
      }
    }
  }

  let forLease = true;
  let forSale = true;

  if (allStatusStr) {
    forLease = allStatusStr.includes('lease');
    forSale = allStatusStr.includes('sale');
  }

  let allTypeStr = '';
  const typeOptions = document.getElementsByName('type[]')[0] as HTMLSelectElement;
  for (let i = 0; i < typeOptions.selectedOptions.length; i++) {
    if (typeOptions.selectedOptions[i].value) {
      if (allTypeStr === '') {
        allTypeStr = `'${typeOptions.selectedOptions[i].value}'`;
      } else {
        allTypeStr += `,'${typeOptions.selectedOptions[i].value}'`;
      }
    }
  }

  const allTypes = allTypeStr ? allTypeStr.split('\'').join('').split(',') : '';

  const minArea = ($('[name="min-area"]') as HTMLInputElement).value;
  const maxArea = ($('[name="max-area"]') as HTMLInputElement).value;

  const minPriceStr = ($('[name="min-price"]') as HTMLInputElement).value;
  const maxPriceStr = ($('[name="max-price"]') as HTMLInputElement).value;

  let minPrice = 0;
  if (minPriceStr && minPriceStr !== 'any') {
    minPrice = parseFloat(minPriceStr);
  }

  let maxPrice = 100000000;
  if (maxPriceStr && maxPriceStr !== 'any') {
    maxPrice = parseFloat(maxPriceStr);
  }

  if (forLease && !forSale) {
    state.properties = state.properties.filter(p => p.status.toLowerCase().includes('lease') || p.status.toLowerCase().includes('both'));
  } else if (!forLease && forSale) {
    state.properties = state.properties.filter(p => p.status.toLowerCase().includes('sale') || p.status.toLowerCase().includes('both'));
  }

  let types;
  if (allTypes) {
    types = allTypes.map((element) => {
      return element.replace('_fr', '');
    });
  }

  if (types && types.length > 0) {

    const matchTypeP = [];
    let specialMatch;
    state.properties = state.all_properties.filter(p => p.province.toLowerCase() !== 'qc'
      || (p.province.toLowerCase() === 'qc' && p.property_type[0] &&
        (!p.property_type[0].toLowerCase().includes('duplex')
          && !p.property_type[0].toLowerCase().includes('triplex')
          && !p.property_type[0].toLowerCase().includes('quadruplex')
        )
      ));

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'multi-family')
      &&
      (hasPropertyType(p.property_type[0], 'multifamily')
        || hasPropertyType(p.property_type[0], 'condo') || hasPropertyType(p.property_type[0], 'unit')
        || hasPropertyType(p.property_type[0], 'duplex') || hasPropertyType(p.property_type[0], 'triplex')
        || hasPropertyType(p.property_type[0], 'fourplex') || hasPropertyType(p.property_type[0], 'quintuplex')
        || hasPropertyType(p.property_type[0], 'two or more storey')
      )
    );
    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'retail')
      && hasPropertyType(p.property_type[0], 'hospitality'));

    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'land')
      &&
      (
        hasExactPropertyType(p.property_type[0], 'lot') || hasExactPropertyType(p.property_type[0], 'part woods')
        || hasExactPropertyType(p.property_type[0], 'part bush') || hasExactPropertyType(p.property_type[0], 'part cleared') || hasExactPropertyType(p.property_type[0], 'part workable')
        || hasPropertyType(p.property_type[0], 'mobile/mini') || hasPropertyType(p.property_type[0], 'no building onsite')
        || hasPropertyType(p.property_type[0], 'vacant') || hasPropertyType(p.property_type[0], 'acreage')

      ));
    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'agricultural')
      &&
      (hasPropertyType(p.property_type[0], 'agriculture') || hasPropertyType(p.property_type[0], 'farm'))
    );

    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'other')
      &&
      (
        hasExactPropertyType(p.property_type[0], 'commercial') || hasExactPropertyType(p.property_type[0], 'res')
        || hasPropertyType(p.property_type[0], 'bulk')
        || hasPropertyType(p.property_type[0], 'residential') || hasPropertyType(p.property_type[0], 'detached')
        || hasPropertyType(p.property_type[0], 'parking') || hasPropertyType(p.property_type[0], 'unknown')
        || (p.property_type[0] && p.property_type[0].indexOf('year round access') >= 0)
      ));

    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'hotels/motels')
      &&
      (hasPropertyType(p.property_type[0], 'hospitality'))
    );

    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    specialMatch = state.properties.filter(p => p.property_type && types.find(t => t === 'investment')
      &&
      (hasPropertyType(p.property_type[0], 'investment') || hasPropertyType(p.property_type[0], 'institutional'))
    );

    specialMatch.forEach((s) => {
      if (!matchTypeP.includes(s)) {
        matchTypeP.push(s);
      }
    });

    types.forEach((t) => {
      state.properties.filter(p => p.property_type && hasPropertyType(p.property_type[0], t)).forEach((item) => {
        if (!matchTypeP.includes(item)) {
          matchTypeP.push(item);
        }
      });

    });
    state.properties = matchTypeP;
  }

  if (minArea) {
    state.properties = state.properties.filter(p => p.total_area >= parseInt(minArea));
  }

  if (maxArea) {
    state.properties = state.properties.filter(p => p.total_area <= parseInt(maxArea));
  }

  if (minPrice) {
    if (!forLease && !forSale || forLease && forSale) {
      state.properties = state.properties.filter((p) => {
        if (p.status === 'both') {
          return (p.lease_price >= minPrice || p.sale_price >= minPrice);
        } else if (p.status === 'sale') {
          return (p.sale_price >= minPrice);
        } else if (p.status === 'lease') {
          return (p.lease_price >= minPrice);
        } else {
          return false;
        }
      }
      );
    } else if (forLease && !forSale) {
      state.properties = state.properties.filter((p) => {
        if (p.status === 'lease') { return (p.lease_price >= minPrice); } else { return false; }
      }
      );
    } else if (!forLease && forSale) {
      state.properties = state.properties.filter((p) => {
        if (p.status === 'sale') { return (p.sale_price >= minPrice); } else { return false; }
      }
      );
    }
  }

  if (maxPrice) {
    if (!forLease && !forSale || forLease && forSale) {
      state.properties = state.properties.filter((p) => {
        if (p.status === 'both') {
          return (p.lease_price <= maxPrice || p.sale_price <= maxPrice);
        } else if (p.status === 'sale') {
          return (p.sale_price <= maxPrice);
        } else if (p.status === 'lease') {
          return (p.lease_price <= maxPrice);
        } else {
          return false;
        }
      }
      );
    } else if (forLease && !forSale) {
      state.properties = state.properties.filter((p) => {
        if (p.status === 'lease') { return (p.lease_price <= maxPrice); } else { return false; }
      }
      );
    } else if (!forLease && forSale) {
      state.properties = state.properties.filter((p) => {
        if (p.status === 'sale') { return (p.sale_price <= maxPrice); } else { return false; }
      }
      );
    }
  }

  const exclusiveListing = ($('[name="exclusiveListing"]') as HTMLInputElement).checked;

  if (exclusiveListing) {

    state.properties = state.properties.filter(p => (checkValueInArray(state.commercialAgents, 'alaia_id', p.agent_id)
      || checkValueInArray(state.commercialAgents, 'id', p.agent_person_id)
      || checkValueInArray(state.commercialAgents, 'alaia_id', p.agent2_id)
      || checkValueInArray(state.commercialAgents, 'id', p.agent2_person_id)) && (p.feedId === 2 || p.feedId === 41)
    );
  }

  state.properties = sortProperties(state.properties, state.sortby);

  state.pageProperties = paginateAssets(state.properties, 1);
  state.page = 1;

  return state;

};

export default class searchResult extends Component {

  view = (state) => {

    if (state.pageProperties === undefined) { return; }

    const params = new URLSearchParams(state.queryString);
    params.set('sortby', state.sortby ? state.sortby : '');
    app.render($('#resultFound'), <PageControl page={state.page} total={state.properties.length} size={PageSize} event='/gotoPage' type='property' isMlsDeleted={state.mlsDeleted} />);

    return (
      <div>
        <div id='houzez_ajax_container'>
          <div class='card-deck'>
            {state.highlighedProp &&
              <div style='width:100%'><Porperty property={state.highlighedProp} hightlight={true} />
                <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
              </div>}
            {state.pageProperties.map(p => <Porperty property={p} hightlight={false} />)}
          </div>

          {state.properties.length && !state.mlsDeleted ? <PageControl page={state.page} total={state.properties.length} size={PageSize} event='/gotoPage' type='property' isMlsDeleted={state.mlsDeleted} /> : <></>}
          <p></p>
        </div >

      </div>
    );
  };

  update = {
    '#': async (state) => {

      const pathSegments = window.location.pathname.split('/');
      let param1 = '';
      let param2 = '';
      if (lang.get() === 'en' && pathSegments.length === 4) {
        param1 = pathSegments[pathSegments.length - 1];
        param2 = pathSegments[pathSegments.length - 2];
      }

      if (lang.get() === 'fr' && pathSegments.length === 5) {
        param1 = pathSegments[pathSegments.length - 1];
        param2 = pathSegments[pathSegments.length - 2];
      }

      let keyword = '';
      if (param2 && param2.trim()) {
        keyword = param2.trim();
        if (param1 && param1.trim()) {
          keyword = `${param1.trim()}, ${keyword}`;
        }
      }
      // find html element of properties-location-title and replace $location with keyword
      const locationTitle = $('#properties-location-title');
      if (locationTitle) {
        locationTitle.innerHTML = locationTitle.innerHTML.replace('City, Province', keyword.toUpperCase());
      }

      checkMapList();
      const params = new URLSearchParams(location.search);
      const keywordParam = params.get('keyword')?.trim().replace('/', '') || '';
      if (keywordParam) {
        keyword = keywordParam;
      }

      const sortBy = params.get('sortby') ? params.get('sortby') : '';

      setSort(sortBy);
      state.highlighedProp = null;

      state.commercialAgents = await getCommercialAgents();

      if (keyword) {
        const mlsMatch = await getPropertyByID(keyword);

        //gcode is array means cosmos results found, if not returns google geocode
        const quebecmulti = (mlsMatch && mlsMatch.province.toLowerCase() === 'qc' && mlsMatch.property_type[0] &&
          (mlsMatch.property_type[0].toLowerCase().includes('duplex')
            || mlsMatch.property_type[0].toLowerCase().includes('triplex')
            || mlsMatch.property_type[0].toLowerCase().includes('quadruplex'))
        ) ?? false;

        if (mlsMatch && quebecmulti === false) {
          mlsMatch.distance = 0;
          const properties = [mlsMatch];
          app.run('map', getMapProperties(properties), false);
          return {
            all_properties: properties,
            properties,
            unfilteredProperties: properties,
            pageProperties: properties,
            page: 1,
            sortby: '',
            mlsMatch: true
          };
        }

        if (!mlsMatch) {
          const mlsDeleted = await getDeletedPropertyByID(keyword);

          if (mlsDeleted) {
            let properties = await getSimilarListing(mlsDeleted.postal_code, mlsDeleted.property_type[0]);

            if (properties.length) {
              const center_lat = mlsDeleted.latitude;
              const center_lng = mlsDeleted.longitude;

              properties.forEach((p) => {
                p.distance = distance(p.latitude, p.longitude, center_lat, center_lng);
              });

              properties.sort((a, b) => a.distance - b.distance);

              properties = properties.slice(0, 6);
            }

            app.run('map', getMapProperties(properties), false);
            return {
              all_properties: properties,
              properties,
              unfilteredProperties: properties,
              pageProperties: properties,
              page: 1,
              sortby: '',
              mlsMatch: false,
              mlsDeleted: true
            };
          }
        }
      }

      state.mlsMatch = false;
      state.mlsDeleted = false;

      const gcode = await getGeoCode(keyword);
      const localcode = gcode.find(g => g.types.includes('locality'));
      const bounds = (localcode || gcode[0]).geometry.viewport;
      if (!localcode && gcode.length === 1 && gcode[0].types[0] === 'country') {
        state.no_result = true;
      } else {
        state.no_result = false;
      }
      app.run('/map-set-boundary', bounds);
      return state;
    },

    '/highlight-card': async (state, map_property) => {
      moveTo('.card:first-of-type');
      let highlighedProp = '';
      if (map_property) {
        highlighedProp = state.all_properties.find(p => p.id === map_property.id);
      }
      return { ...state, highlighedProp };
    },

    '/sort': async (state) => {
      const s = $('#ajax_sort_properties') as HTMLInputElement;
      state.sortby = s.value;

      state.properties = sortProperties(state.properties, s.value);

      state.page = 1;
      state.pageProperties = paginateAssets(state.properties, 1);

      return state;
    },

    '/filter-list': (state) => {
      showLoading('#resultFound');
      state.properties = state.unfilteredProperties;
      state = filterProperties(state);
      app.run('map', getMapProperties(state.properties), true);
      this.pushHistory();
      return state;
    },

    '/set_map_view': async (state, v) => {

      const url = new URL(window.location.href);
      const last_map_view = url.searchParams.get('map_view');

      if (v !== last_map_view) {
        url.searchParams.set('map_view', v);
        window.history.pushState({}, '', url.href);
      }

      return state;
    },

    '/map-load-list': async (state, lowerBounds, upperBounds) => {

      if (state.mlsMatch || state.mlsDeleted) {
        return;
      }

      const dx = upperBounds.lat - lowerBounds.lat;
      const dy = upperBounds.lng - lowerBounds.lng;

      if (dx > 5 || dy > 5) {

        if (state.no_result) {
          $('#resultFound').innerHTML = '<b>' + __('Sorry, no Properties found. Please refine your search.') + '</b>';
        } else {
          $('#resultFound').innerHTML = '<b>' + __('Too big geographical area. Please refine the search.') + '</b>';
        }
        const houzez_ajax_container = $('#houzez_ajax_container');
        if (houzez_ajax_container) {
          $('#houzez_ajax_container').innerHTML = '';
        }
        app.run('map', [], true);
        return;
      }

      showLoading('#resultFound');

      state.all_properties = await getPropertiesInside_cosmos(
        {
          lowerBounds,
          upperBounds
        });

      state.properties = state.all_properties.filter(p => p.province.toLowerCase() !== 'qc'
        || (p.province.toLowerCase() === 'qc' && p.property_type[0] &&
          (!p.property_type[0].toLowerCase().includes('duplex')
            && !p.property_type[0].toLowerCase().includes('triplex')
            && !p.property_type[0].toLowerCase().includes('quadruplex')
          )
        ));

      state = filterProperties(state);
      state.unfilteredProperties = state.all_properties;

      app.run('map', getMapProperties(state.properties), true);
      return state;
    },

    '/map-refresh-list': (state, bounds) => {

      if (!state.all_properties) { return; }
      showLoading('#resultFound');
      state.properties = state.all_properties.filter(p => bounds.contains(L.latLng(p.latitude, p.longitude)));

      state = filterProperties(state);
      state.unfilteredProperties = state.properties;

      return state;

    },

    '/gotoPage': (state, targetPageNumber) => {
      state.page = targetPageNumber;
      state.pageProperties = paginateAssets(state.properties, targetPageNumber);
      return { ...state };
    },

    '/setFilterComponentState': async (state, { minPriceStr, maxPriceStr, forLease, forSale, allTypes, keyword, minArea, maxArea, sortBy, page, minPrice, maxPrice, exclusivelisting }) => {
      state = { ...state, minPriceStr, maxPriceStr, forLease, forSale, allTypes, keyword, minArea, maxArea, sortBy, page, minPrice, maxPrice, exclusivelisting };
      return state;
    },

    'close-highlighed-card': (state) => {
      document.querySelector('form').scrollIntoView();
      state.highlighedProp = null;
      return state;
    }
  };

  private pushHistory() {
    const url = new URL(window.location.href);

    const params = new URLSearchParams(location.search);

    const urlminarea = params.get('min-area');
    const urlmaxarea = params.get('max-area');
    const urlminprice = params.get('min-price');
    const urlmaxprice = params.get('max-price');
    const urlexclusivelisting = params.get('exclusive-listing');

    url.searchParams.delete('type[]');

    url.searchParams.delete('status[]');

    let allTypeStr = '';
    const types = document.getElementsByName('type[]')[0] as HTMLSelectElement;
    for (let i = 0; i < types.selectedOptions.length; i++) {
      if (types.selectedOptions[i].value) {
        if (allTypeStr === '') {
          allTypeStr = `'${types.selectedOptions[i].value}'`;
        } else {
          allTypeStr += `,'${types.selectedOptions[i].value}'`;
        }
      }
    }

    const statuses = document.getElementsByName('status[]')[0] as HTMLSelectElement;

    for (let i = 0; i < statuses.selectedOptions.length; i++) {
      if (statuses.selectedOptions[i].value) {
        url.searchParams.append('status[]', statuses.selectedOptions[i].value.toLowerCase());
      }
    }

    for (let i = 0; i < types.selectedOptions.length; i++) {
      if (types.selectedOptions[i].value) {
        url.searchParams.append('type[]', types.selectedOptions[i].value.toLowerCase());
      }
    }

    const minArea = ($('[name="min-area"]') as HTMLInputElement).value;
    const maxArea = ($('[name="max-area"]') as HTMLInputElement).value;

    const minPrice = ($('[name="min-price"]') as HTMLInputElement).value;
    const maxPrice = ($('[name="max-price"]') as HTMLInputElement).value;

    if (urlminarea || urlminarea === '') {
      url.searchParams.set('min-area', minArea);
    } else {
      url.searchParams.append('min-area', minArea);
    }

    if (urlmaxarea || urlmaxarea === '') {
      url.searchParams.set('max-area', maxArea);
    } else {
      url.searchParams.append('max-area', maxArea);
    }

    if (urlminprice || urlminprice === '') {
      url.searchParams.set('min-price', minPrice);
    } else {
      url.searchParams.append('min-price', minPrice);
    }

    if (urlmaxprice || urlmaxprice === '') {
      url.searchParams.set('max-price', maxPrice);
    } else {
      url.searchParams.append('max-price', maxPrice);
    }

    const exclusivelisting = ($('[name="exclusiveListing"]') as HTMLInputElement).checked;

    if (urlexclusivelisting || urlexclusivelisting === '') {
      url.searchParams.set('exclusive-listing', exclusivelisting ? '1' : '');
    } else {
      url.searchParams.append('exclusive-listing', exclusivelisting ? '1' : '');
    }

    window.history.pushState('', '', url.href);
  }
}

new SearchFilter().mount('.advanced-search.advanced-search-half-map');
new searchResult().start('.listing-view');
new InquiryForm({ isPopup: true }).start('.mobile-property-form .modal-body');

window.addEventListener('resize', checkMapList);
